exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_agrupacion, .table_agrupacion tr, .table_agrupacion tr td{\n    margin: 0;\n    padding: 0 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/forms/producto-frm-add/producto-frm-add.component.css
// module id = ../../../../../src/app/forms/producto-frm-add/producto-frm-add.component.css
// module chunks = main